import axios from 'axios'
import { API_BASE_URL, STORAGE_KEYS } from '../utils/constants'
import toast from 'react-hot-toast'

// Global token expiration handler
let tokenExpiredHandler = null

export const setTokenExpiredHandler = (handler) => {
  tokenExpiredHandler = handler
}

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
})

// Log API configuration on initialization
console.log('🔧 API Client initialized with baseURL:', API_BASE_URL)

// Request interceptor - attach auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      console.log('🔐 Request with token:', config.url)
    } else {
      console.warn('⚠️ No token found for request:', config.url)
    }
    return config
  },
  (error) => {
    console.error('❌ Request interceptor error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor - handle errors globally
apiClient.interceptors.response.use(
  (response) => {
    console.log('✅ Response received:', response.config.url, response.status)
    return response
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response

      // Handle 401 Unauthorized - show non-dismissible modal (do not navigate automatically)
      if (status === 401) {
        localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
        localStorage.removeItem(STORAGE_KEYS.MERCHANT_ID)
        // Trigger token expired handler if available - this will show the modal
        if (tokenExpiredHandler) {
          tokenExpiredHandler(true)
        }
        // Do NOT navigate automatically - only navigate when user clicks unlock button
        return Promise.reject(error)
      }

      // Handle 403 Forbidden
      if (status === 403) {
        toast.error('You do not have permission to perform this action.')
        return Promise.reject(error)
      }

      // Handle 404 Not Found
      if (status === 404) {
        toast.error(data?.message || 'Resource not found.')
        return Promise.reject(error)
      }

      // Handle 400 Bad Request
      if (status === 400) {
        const message = data?.message || 'Invalid request.'
        toast.error(message)
        return Promise.reject(error)
      }

      // Handle 500 Server Error
      if (status >= 500) {
        toast.error('Server error. Please try again later.')
        return Promise.reject(error)
      }

      // Generic error message
      const message = data?.message || 'An error occurred.'
      toast.error(message)
    } else if (error.request) {
      toast.error('Network error. Please check your connection.')
    } else {
      toast.error('An unexpected error occurred.')
    }

    return Promise.reject(error)
  }
)

export default apiClient

